// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2JROz","detailsBorder":"styles_detailsBorder__1DXen"};